/*
 * Map fields to be used in Address and Location components specific for Adalia M&E.
 */
import React from "react";

import Base from './base.jsx'; 
import { Mode } from "../common.jsx";
import Helpers from './helpers.jsx'
import Setting from "./setting.jsx";

import GridLayout from './grid_layout.jsx';
export class AdaliaMEMapGrid extends GridLayout {
  static defaultContent(language) {
    return Object.assign(super.defaultContent(language), {
      deletable: false,
      sortable: false,
      reportKey: "",
    });
  }

  renderSettings() {}
}

export class AdaliaMEMap extends Base {
  static defaultContent(language) {
    return Object.assign(super.defaultContent(language), {
      name: "field_" + Helpers.randomString(),
      deletable: false,
      sortable: false,
    });
  }

  constructor(props) {
    super(props);

    this.mapRef = React.createRef();
  }

  renderView() {
    return (
      <div>
        <div ref={this.mapRef} className="map"></div>
        {this.renderAfterMap()}
      </div>
    );
  }

  locationPickerInitialized = () => {};

  getFillModeOptions() {
    return {
      enableAutocomplete: true,
      enableAutocompleteBlur: true,
      onchanged: this.locationChanged,
      oninitialized: this.locationPickerInitialized,
    };
  }

  fieldInitialized() {
    return true;
  }

  componentDidMount() {
    super.componentDidMount();

    let mapContainer = jQuery(this.mapRef.current);
    let inputGrid = jQuery(this.refs.root).closest(`.${this.constructor.PARENT_TYPE}`).find(`.${this.constructor.PARENT_TYPE}_grid`);

    // Match heights for visual appeal
    mapContainer.outerHeight(inputGrid.innerHeight());

    if (this.fieldInitialized()) {
      const initialLocation = this.getInitialLocation(inputGrid);

      let options = {
        location: initialLocation,
        radius: 0,
        zoom: initialLocation.latitude != "0.0" && initialLocation.longitude != "0.0" ? 15 : 1,
      };

      // Make map editable on form fill
      if (this.props.mode == Mode.FILL) {
        options = {
          ...options,
          ...this.getFillModeOptions(inputGrid),
        };
      }
      // Disable drag and marker drag when uneditable
      if (this.props.mode == Mode.VIEW) {
        options = { ...options, draggable: false, markerDraggable: false };
      }

      mapContainer.locationpicker(options);

      this.initInputEvents(inputGrid, mapContainer);
    }
  }

  renderSettings() {
    return (
      <div>
        <Setting.TextField
          name="reportKey"
          label={I18n.t('field_report_key', {scope: 'fe'})}
          value={this.props.content.reportKey}
          description={I18n.t('field_report_key_description', {scope: 'fe'})}
          {...(this.allowModifyInSafeMode ? {onChange: this.updateSettings} : {disabled: true})}
        />
      </div>
    );
  }
}
